angular.module('app.brands', ['ngRoute', 'ngResource', 'angular-jwt', 'ngFileUpload', 'bw.paging', 'uiGmapgoogle-maps'])
.config(['$routeProvider', function _($routeProvider) {
  $routeProvider.when('/service/brands/brands', {
    template: require('./brands.html'),
    controller: 'brandsCtrl',
  });
}]).controller('brandsCtrl', ($rootScope, $scope, $translate, $resource, $route, $location, $cookies, $routeParams, $window, AuthService, envService) => {
  $rootScope.mainmenu = 'service';
  $rootScope.menu = 'brands';

  const APIURL = envService.read('apiUrl');
  if (!AuthService.isAuthenticated()) {
    $location.path('/login');
    return;
  }

  $scope.modifyMode = false;
  $scope.sortMode = false;
  $scope.query = '';
  $scope.targetPage = 1;
  $scope.totalCount = 0;
  $scope.brands = [];
  $scope.selectedBrands = {};
  $scope.addBrands = {};

  $resource(`${APIURL}/admin/cars/brands/list`).get({ q: $scope.query }, (data) => {
    $scope.brands = data.brands;
    $scope.totalCount = data.totalCount;
  }, (err) => {
    console.error(err);
    if (err.data && err.data.msg) {
      alert(err.data.msg);
    } else {
      alert($translate.instant('알수 없는 에러 입니다.'));
    }
  });

  $scope.paging = (page) => {
    $scope.targetPage = page;
    $resource(`${APIURL}/admin/cars/brands/list`).get({ page: page - 1, q: $scope.query }, (data) => {
      $scope.brands = data.brands;
      $scope.totalCount = data.totalCount;
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };

  $scope.sortable = (isSortable) => {
    if (isSortable === false) {
      $scope.sortMode = isSortable;
      const sortedIds = [];
      $scope.brands.every((brand) => {
        sortedIds.push(brand.ID);
        return (brand.ID);
      });
      $resource(`${APIURL}/admin/cars/brands/modify/sort`).save({ TB_CAR_MAKER_IDS: sortedIds }, () => {
        $scope.paging(1);
      }, (err) => {
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
    } else {
      $scope.sortMode = isSortable;
      $scope.query = '';
      $scope.targetPage = 1;
      $resource(`${APIURL}/admin/cars/brands/list`).get({ count: $scope.totalCount }, (data) => {
        $scope.brands = data.brands;
        $scope.totalCount = data.totalCount;
      }, (err) => {
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
    }
  };
  $scope.view = (brands) => {
    $scope.modifyMode = false;
    $scope.selectedBrands = brands;
    jQuery('#modal-brand').modal('show');
  };
  $scope.addView = () => {
    $scope.addBrands = {};
    jQuery('#modal-brand-add').modal('show');
  };
  $scope.modify = () => {
    angular.copy($scope.selectedBrands, $scope.addBrands);
    $scope.modifyMode = true;
  };
  $scope.delete = () => {
    if ($window.confirm($translate.instant('선택한 제조사를 삭제하면 제조사에 속한 차량 정보도 모두 삭제됩니다. 삭제 하시겠습니까?'))) {
      $resource(`${APIURL}/admin/cars/brands/${$scope.selectedBrands.MAKER_CD}`).delete(() => {
        $scope.paging($scope.targetPage);
        jQuery('#modal-brand').modal('hide');
      }, (err) => {
        console.error(err);
        if (err.data && err.data.msg) {
          alert(err.data.msg);
        } else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
    }
  };
  $scope.modifySubmit = () => {
    $resource(`${APIURL}/admin/cars/brands/${$scope.addBrands.MAKER_CD}`).save({ NAME: $scope.addBrands.MAKER_NAME, SORT: $scope.addBrands.SORT }, () => {
      $scope.paging($scope.targetPage);
      jQuery('#modal-brand').modal('hide');
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };
  $scope.submit = () => {
    if (!$scope.addBrands || !$scope.addBrands.MAKER_NAME) {
      alert($translate.instant('이름을 입력해 주세요.'));
      return;
    }
    $resource(`${APIURL}/admin/cars/brands`).save({ NAME: $scope.addBrands.MAKER_NAME }, () => {
      $scope.paging($scope.targetPage);
      jQuery('#modal-brand-add').modal('hide');
    }, (err) => {
      console.error(err);
      if (err.data && err.data.msg) {
        alert(err.data.msg);
      } else {
        alert($translate.instant('알수 없는 에러 입니다.'));
      }
    });
  };
});



// WEBPACK FOOTER //
// ./src/app/service/brands/brands.js